<template>
  <v-list nav dense>
    <v-list-group
      active-class="white--text"
      v-for="(item, key) in items"
      :key="key"
    >
      <template v-slot:activator>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </template>

      <template v-for="(val, subKey) in item.subRoutes">
        <v-list-item
          link
          :to="val.path"
          active-class="white--text"
          :key="subKey"
          v-if="val.isAuthorized"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-list-item-content class="pl-4" v-on="on">
                <v-list-item-title v-text="val.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ val.title }}</span>
          </v-tooltip>
        </v-list-item>
      </template>
    </v-list-group>
  </v-list>
</template>
<script>
const API_ENDPOINT = "/api/routing";
export default {
  data: () => ({
    items: []
  }),
  methods: {
    getMenu() {
      this.$axios
        .get(`${API_ENDPOINT}/admin`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  mounted() {
    this.getMenu();
  }
};
</script>
